import {
  COUNTY_LEVEL_LAYER,
  LEVEL_LAYER,
  STATE_LEVEL_LAYER,
} from '../../map/mapbox/services/layer-store.service';

/**
 * Mapbox place types that name an area the map already draws as one whole
 * feature: `region` is a US state, `district` a US county. Everything else a
 * search can return - an address, a POI, a city, a ZIP - is a point, and keeps
 * resolving to the 1-mile cell it falls in.
 */
const LEVEL_BY_PLACE_TYPE: { [placeType: string]: LEVEL_LAYER } = {
  region: STATE_LEVEL_LAYER,
  district: COUNTY_LEVEL_LAYER,
};

/**
 * The level layer a geocoder result *is*, or null when the result is a point.
 * Only the first `place_type` counts: it is the feature's own type, and a city
 * that shares its name with a county ("Denver") must stay a point.
 */
export function geocoderResultLevel(result: {
  place_type?: string[];
}): LEVEL_LAYER | null {
  return LEVEL_BY_PLACE_TYPE[result?.place_type?.[0] ?? ''] ?? null;
}
